// components/steps/OrderPreferencesStep.jsx
import React from 'react';
import { Form, Button } from 'antd';

const OrderPreferences = ({ 
  form, 
  subStep, 
  setSubStep, 
  setCurrentStep, 
  orderOption, 
  setOrderOption, 
  deliveryMethod, 
  setDeliveryMethod 
}) => {
  return (
    <div className="step-content">
      {/* <h3 className="step-title">Order Instructions</h3> */}

      {/* {subStep === 0 && (
        <div className="step-1">
          <Form.Item
            name="orderOption"
            label="Who do you want to order your medication from?"
            rules={[{ required: true, message: 'Please select an option' }]}
          >
            <div className="radio-group">
              {['us', 'other'].map((value) => {
                const isActive = form.getFieldValue('orderOption') === value;
                return (
                  <div
                    key={value}
                    className={`input-radio ${isActive ? 'active-check' : ''}`}
                    onClick={() => {
                      form.setFieldsValue({ orderOption: value });
                      setOrderOption(value);
                    }}
                  >
                    <input
                      type="radio"
                      value={value}
                      name="orderOption"
                      checked={isActive}
                      readOnly
                    />
                    <div className="input-radio-box_wrap">
                      <div className="input-radio-box">
                        <div className="label-check"></div>
                        <h6>{value === 'us' ? 'My Private Chemist' : 'Another pharmacy'}</h6>
                      </div>
                      {isActive && (
                        <div className="info-box-inline">
                          <p className="mb-0">
                            <strong>Note:</strong>{" "}
                            {value === 'us'
                              ? 'My Private Chemist will provide your medications.'
                              : 'You will get your medications from your chosen pharmacy.'}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Form.Item>
        </div>
      )} */}
      
        <div className="step-2">
            <Form.Item
            name="deliveryMethod"
            label="How would you like to receive your medication?"
            rules={[{ required: true, message: 'Please select delivery method' }]}
            >
            <div className="radio-group">
                {['delivery', 'clinic'].map((value) => {
                const isActive = deliveryMethod === value;
                const isDisabled = deliveryMethod && !isActive;

                return (
                    <div
                    key={value}
                    className={`input-radio ${isActive ? 'active-check' : ''} ${isDisabled ? 'inactive-check' : ''}`}
                    onClick={() => {
                        form.setFieldsValue({ deliveryMethod: value });
                        setDeliveryMethod(value);
                    }}
                    >
                    <input
                        type="radio"
                        value={value}
                        name="deliveryMethod"
                        checked={isActive}
                        readOnly
                    />
                    <div className="input-radio-box_wrap">
                        <div className="input-radio-box">
                        <div className="label-check"></div>
                        <h6>{value === 'delivery' ? 'Deliver to my address' : 'I will collect from clinic'}</h6>
                        </div>
                        {isActive && (
                        <div className="info-box-inline">
                            <p className="mb-0" style={{fontSize:'12px'}}>
                            <img src="/assets/images/information.png" alt="info"  style={{width: "18px"}} />{" "}
                            {value === 'delivery'
                                ? "My Private Chemist will deliver your medications at your address."
                                : "You'll collect medications  from My Private Chemist."}
                            </p>
                        </div>
                        )}
                    </div>
                    </div>
                );
                })}
            </div>
            </Form.Item>
        </div>
      

      {/* Unified Button Controls
      <div className="step-actions sub-step-actions">
        <Button
          onClick={() => {
            if (subStep === 0) {
              setCurrentStep(prev => prev - 1);
            } else {
              setSubStep(subStep - 1);
            }
          }}
          className="prev-button"
          style={{ marginRight: 8 }}
        >
          Back
        </Button>

        <Button
          type="primary"
          className="next-button"
          onClick={() => {
            if (subStep === 0) {
              form.validateFields(['orderOption']).then(() => {
                setSubStep(1);
              });
            } else if (subStep === 1) {
              form.validateFields(['deliveryMethod']).then(() => {
                setCurrentStep((prev) => prev + 1);
                setSubStep(0); // Reset substep for future use
              });
            }
          }}
        >
          <span>
            Next
          </span>
        </Button>
      </div> */}
    </div>
  );
};

export default OrderPreferences;